// create flux standard actions (FSA)
// payload and action creator
import { createAction, COPY2PAYLOAD, GENERATOR } from 'uix/actions';
// maybe handle simple signal with saga
export let sendSignal = createAction('SEND_SIGNAL', COPY2PAYLOAD);
// COPY2PAYLOAD gives us "everything" in action.payload
// for someSpecialAction({everything})
// each new action gets a increased action.meta.aSpecialVersion
export let someSpecialAction = createAction('SOMETHING_SPECIAL', COPY2PAYLOAD, GENERATOR('aSpecialVersion'));
